import React from 'react';
import { Link } from 'react-router-dom';
import { PlayCircle, GraduationCap, Mail } from 'lucide-react';
import { Button } from '../components/ui/button';
import { artistInfo } from '../data/mock';

export const Home = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative h-screen flex items-center justify-center overflow-hidden">
        {/* Background Image with Overlay */}
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: 'url(https://customer-assets.emergentagent.com/job_dance-heritage-2/artifacts/z30ioaf7_IMG_0242.JPG)',
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-maroon/80 via-maroon/70 to-maroon/90"></div>
        </div>

        {/* Hero Content */}
        <div className="relative z-10 text-center px-4 max-w-4xl mx-auto fade-in">
          <p
            className="font-script text-4xl md:text-5xl text-gold mb-2 animate-fade-in"
            style={{ textShadow: '0 2px 14px rgba(212, 175, 55, 0.45)' }}
            data-testid="hero-learn-from"
          >
            Learn from
          </p>
          <h1 className="text-5xl md:text-7xl font-bold text-ivory mb-6 tracking-wide animate-fade-in">
            {artistInfo.name}
          </h1>
          <p className="text-xl md:text-2xl text-gold mb-8 leading-relaxed italic">
            {artistInfo.tagline}
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Link to="/performances">
              <Button className="bg-gold text-maroon hover:bg-gold/90 px-8 py-6 text-base font-medium flex items-center gap-2">
                <PlayCircle size={20} />
                Watch Performances
              </Button>
            </Link>
            <Link to="/classes">
              <Button className="bg-ivory text-maroon hover:bg-ivory/90 px-8 py-6 text-base font-medium flex items-center gap-2">
                <GraduationCap size={20} />
                Learn Bharatanatyam
              </Button>
            </Link>
            <Link to="/contact">
              <Button variant="outline" className="border-2 border-ivory text-ivory hover:bg-ivory hover:text-maroon px-8 py-6 text-base font-medium flex items-center gap-2">
                <Mail size={20} />
                Contact
              </Button>
            </Link>
          </div>
        </div>

        {/* Decorative Pattern */}
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-ivory to-transparent"></div>
      </section>

      {/* Introduction Section */}
      <section className="py-20 bg-ivory">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-bold text-maroon mb-6">
              Welcome to the World of Bharatanatyam
            </h2>
            <p className="text-lg text-maroon-dark leading-relaxed mb-8">
              Experience the divine art form that has captivated audiences for centuries. Through intricate footwork, 
              expressive abhinaya, and devotional storytelling, Bharatanatyam brings ancient traditions to life.
            </p>
          </div>
        </div>
      </section>

      {/* Featured Highlights */}
      <section className="py-20 bg-gradient-to-b from-ivory to-cream">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Experience */}
            <div className="text-center p-8 bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
              <div className="w-20 h-20 bg-maroon rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl font-bold text-gold">15+</span>
              </div>
              <h3 className="text-2xl font-semibold text-maroon mb-2">Years</h3>
              <p className="text-maroon-dark">
                Of dedicated practice and performances across India and internationally
              </p>
            </div>

            {/* Training */}
            <div className="text-center p-8 bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
              <div className="w-20 h-20 bg-maroon rounded-full flex items-center justify-center mx-auto mb-4">
                <GraduationCap className="text-gold" size={40} />
              </div>
              <h3 className="text-2xl font-semibold text-maroon mb-2">Thanjavur</h3>
              <p className="text-maroon-dark">
                Trained under Guru Dr Sandhya Purechcha
              </p>
            </div>

            {/* Performances */}
            <div className="text-center p-8 bg-white rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
              <div className="w-20 h-20 bg-maroon rounded-full flex items-center justify-center mx-auto mb-4">
                <span className="text-3xl font-bold text-gold">50+</span>
              </div>
              <h3 className="text-2xl font-semibold text-maroon mb-2">Performances</h3>
              <p className="text-maroon-dark">
                At major festivals including Margazhi and Khajuraho
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};
